import structureTypes from '../../../../common/constants/structureTypes'
import ServerPage from '../../../../server/types/ServerPageInterface'
import { migrateCommand } from '../utils/migrateCommand'
import { migrateOfferPrice } from './migrateOfferPrice'

export default function (page: ServerPage): [ServerPage, boolean] {
  return migrateCommand({
    page,
    structureType: structureTypes.OFFER_PRICE,
    migrateFunction: migrateOfferPrice,
  })
}
